<template>
  <v-container
    fill-height
    justify-content-start
    :class="{'pa-2': $vuetify.breakpoint.xsOnly}"
    class="app-section-width"
  >
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="exit()">
          <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">{{getDashboardName({url: $route.path})}}</v-toolbar-title>
      </v-toolbar>
      <h2 class="grey--text">{{$t('activities.by_category')}}</h2>
      <v-flex class="app-scroll-section pa-2">
        <v-layout row hide-details align-top>
          <v-flex xs12 sm6 v-for="(item, index) in onlyCategoriesWithActivities" :key="index">
            <v-layout
              class="activity-button ma-1 pb-3 align-center clickable"
              @click="goTo(item.id)"
              style="padding-top: 70px"
              :style="{ 'background-image': 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' + item.coverImageUrl + ')'}"
            >
              <div class="activity-title mr-5">{{ item.name }}</div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import routeNames from '@/router/routes'
import router from '@/router'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      loading: false,
    }
  },
  created () {
    this.loading = true
    this.$store.dispatch('activities/listCategories').then(async () => {
      await this.$store.dispatch('activities/listActivities')
    }).finally(() => {
      this.loading = false
    })
  },
  computed: {
    ...mapGetters({
      onlyCategoriesWithActivities: 'activities/onlyCategoriesWithActivities',
      getDashboardName: 'service/getDashboardName',
    }),
  },
  methods: {
    exit () {
      router.push({ name: routeNames.main.name })
    },
    goTo (id) {
      router.push({
        name: routeNames.activities.name,
        params: { categoryId: id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.activity-title {
  font-size: 20px;
}
</style>
